import { ResourceModel } from "src/app/core/models/resource.model";

export class Permission extends ResourceModel<Permission> {
    id!: string
    name!: string
    resources!: Array<string>
}